import React, { useEffect, useState }  from 'react';
import * as Loadings from './../../../constants/loadings/backoffice/partners';
import * as R from 'ramda';
import {DeletePartner} from '../../../actions/backoffice/partners';
import { useDispatch } from 'react-redux';
import $ from 'jquery';

export const DeletePartnerModal = ({isLoading, selectedPartner}) => {
	const dispatch = useDispatch();
	if(R.isNil(selectedPartner)){
		return '';
	}
	return (
		<div className="modal fade px-0" id="DeletePartner" aria-labelledby="DeletePartnerLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-sm">
				<div className="modal-content">
					<div className="modal-header">
						<div className="alert alert-danger rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h5 className="sr-only visually-hidden">Supprimer Partenaires</h5>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 font-weight-demi text-danger text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="infoValiderLabel">Supprimer un partenaire</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</div>
					<div className="modal-body scroll-default py-0">
						<div className="h2 lh-copy">Supprimer <span className="font-weight-bold">{R.isNil(selectedPartner) ? 'Partenaire' : selectedPartner.name}</span>?</div>
						<div className="o-80 mt-2">Ce partenaire est sur le point d'être supprimé. Veuillez confirmer cette action.</div>
						<div className="fs-3 o-80 text-danger"><b className="font-weight-black">AVERTISSEMENT</b>: cette action est irréversible.</div>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light mr-2" data-dismiss="modal">Annuler</button>
						{
							isLoading.includes(Loadings.DELETING_PARTNER) ?
								<button className="btn btn-danger loading-btn show">Oui, supprimer le partenaire<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
								:
								<button className="btn btn-danger"
									onClick={(e) => {
										e.preventDefault();
										dispatch(DeletePartner(selectedPartner.id)).then(() => {
											$('.modal').modal("hide");
										})
									}}>
									Oui, supprimer le partenaire
								</button>
						}
					</div>
				</div>
			</div>
		</div>
	);
}